export default {"src":"/_next/static/media/collateral-icon.04d9467a.svg","height":75,"width":76};